import React from 'react';
import { Container, Card, Alert } from 'react-bootstrap';
import { auth } from '../services/firebase';

function Itinerary() {
  const itineraryData = [
    {
      date: 'February 17, 2025',
      time: 'Afternoon',
      title: 'Arrive in Spokane, Washington',
      details: [
        'Drive from Spokane, Washington to Nelson, B.C.',
        <><a href="https://g.co/kgs/T9kuo7P" target="_blank" rel="noopener noreferrer" className="text-decoration-none">Cross at the 24/7 Frontier/Paterson border crossing</a></>,
        <>Stay at the <a href="https://humehotel.com/" target="_blank" rel="noopener noreferrer" className="text-decoration-none">Hume Hotel</a> in Nelson</>
      ],
      alert: '🛂 DON\'T FORGET YOUR PASSPORT! WE WILL LEAVE YOU IN THE US.'
    },
    {
      date: 'February 18, 2025',
      time: 'All Day',
      title: 'Ski White Water Resort',
      details: [
        <>Full day at <a href="https://skiwhitewater.com/" target="_blank" rel="noopener noreferrer" className="text-decoration-none">White Water Ski Resort</a></>,
        'Drive to Meadow Creek B.C. (arrive before 5:00 PM)'
      ]
    },
    {
      date: 'February 19-20, 2025',
      time: 'All Day',
      title: 'Cat Skiing at White Grizzly',
      details: [
        <>Two full days of cat skiing at <a href="https://whitegrizzly.com/" target="_blank" rel="noopener noreferrer" className="text-decoration-none">White Grizzly</a></>
      ]
    },
    {
      date: 'February 21, 2025',
      time: 'All Day',
      title: 'Final Cat Ski Day & Travel to Ainsworth',
      details: [
        <>Final day of cat skiing at <a href="https://whitegrizzly.com/" target="_blank" rel="noopener noreferrer" className="text-decoration-none">White Grizzly</a></>,
        <>Depart to <a href="https://www.ainsworthhotsprings.com/" target="_blank" rel="noopener noreferrer" className="text-decoration-none">Ainsworth Hot Springs</a> in the afternoon</>
      ]
    },
    {
      date: 'February 22, 2025',
      time: 'Early Morning',
      title: 'Return to Spokane',
      details: [
        <>Depart <a href="https://www.ainsworthhotsprings.com/" target="_blank" rel="noopener noreferrer" className="text-decoration-none">Ainsworth Hot Springs</a> at dawn</>,
        'Drive back to Spokane'
      ]
    }
  ];

  if (!auth.currentUser) {
    return (
      <Container className="mt-5">
        <Alert variant="warning">
          Please log in to view the itinerary.
        </Alert>
      </Container>
    );
  }

  return (
    <Container style={{ maxWidth: '1200px', padding: '20px' }}>
      <h2 className="mb-4">Trip Itinerary</h2>
      <Alert variant="info" className="mb-4">
        <i className="bi bi-info-circle-fill me-2"></i>
        This itinerary covers our trip from February 17-22, 2025
      </Alert>
      
      <div className="timeline">
        {itineraryData.map((item, index) => (
          <Card key={index} className="mb-4 border-0 shadow-sm">
            <Card.Body>
              <div className="d-flex align-items-start">
                <div 
                  className="timeline-date text-center me-4"
                  style={{
                    minWidth: '120px',
                    borderRight: '2px solid #dee2e6',
                    paddingRight: '20px'
                  }}
                >
                  <div className="fw-bold">{item.date}</div>
                  <div className="text-muted small">{item.time}</div>
                </div>
                <div className="flex-grow-1">
                  <h4 className="mb-3">{item.title}</h4>
                  <ul className="list-unstyled">
                    {item.details.map((detail, i) => (
                      <li key={i} className="mb-2">
                        <i className="bi bi-arrow-right-short me-2 text-primary"></i>
                        {detail}
                      </li>
                    ))}
                  </ul>
                  {item.alert && (
                    <Alert variant="danger" className="mt-3 mb-0">
                      <i className="bi bi-exclamation-triangle-fill me-2"></i>
                      {item.alert}
                    </Alert>
                  )}
                </div>
              </div>
            </Card.Body>
          </Card>
        ))}
      </div>

      <style>
        {`
          .timeline::before {
            content: '';
            position: absolute;
            left: 145px;
            width: 2px;
            height: calc(100% - 40px);
            background-color: #dee2e6;
            margin-top: 40px;
          }
          @media (max-width: 576px) {
            .timeline::before {
              display: none;
            }
          }
        `}
      </style>
    </Container>
  );
}

export default Itinerary; 